export enum ClauseLibraryViewType {
  MainPage = 'Main Page',
  ClauseForm = 'Clause Form',
  VariationForm = 'Variation Form',
}
